import EditIcon from '@mui/icons-material/Edit';
import { Box, Button, Tooltip, Typography } from '@mui/material';
import { FC } from 'react';
import { Address } from '@acorn-portal/shared/src/services/api';
import { capitalizeFirstLetterOfEachWord } from '@acorn-portal/shared/src/utils';

interface IProps {
	address: Address;
	onEdit: () => void;
}

const AddressDetailView: FC<IProps> = ({ address, onEdit }) => {
	return (
		<Box
			sx={(theme) => ({
				width: '100%',
				position: 'relative',
				border: `1px solid ${theme.palette.common.black}`,
				borderRadius: 2,
				p: 2,
			})}
			onClick={onEdit}
		>
			<Box sx={{ maxWidth: '80%', overflowWrap: 'break-word', textAlign: 'left' }}>
				{address.line1 && <Typography key='line1'>{capitalizeFirstLetterOfEachWord(address.line1)}</Typography>}
				{address.line2 && <Typography key='line2'>{capitalizeFirstLetterOfEachWord(address.line2)}</Typography>}
				{address.line3 && <Typography key='line3'>{capitalizeFirstLetterOfEachWord(address.line3)}</Typography>}
				{address.line4 && <Typography key='line4'>{capitalizeFirstLetterOfEachWord(address.line4)}</Typography>}
				{address.city && <Typography key='city'>{capitalizeFirstLetterOfEachWord(address.city)}</Typography>}
				{address.postcode && (
					<Typography key='postcode'>{capitalizeFirstLetterOfEachWord(address.postcode)}</Typography>
				)}
				{address.county && <Typography key='county'>{capitalizeFirstLetterOfEachWord(address.county)}</Typography>}
				{address.country && <Typography key='country'>{capitalizeFirstLetterOfEachWord(address.country)}</Typography>}
			</Box>
			<Box sx={{ position: 'absolute', top: 10, right: 10 }}>
				<Tooltip title='Edit Address'>
					<Button
						endIcon={<EditIcon />}
						sx={(theme) => ({
							borderRadius: 0,
							padding: 0,
							margin: 1,
							color: theme.palette.primary.main,
							'&:hover': {
								backgroundColor: 'transparent',
								borderBottom: `1px solid ${theme.palette.primary.main}`,
							},
						})}
					>
						Edit
					</Button>
				</Tooltip>
			</Box>
		</Box>
	);
};

export default AddressDetailView;
